import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import layerSlice from './layerSlice';
import loginLayerSlice from './loginLayerSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from "redux-persist"

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["auth"]
}

const rootReducer = combineReducers({
    layer: layerSlice,
    loginLayer: loginLayerSlice,
    auth: authSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store;
export const persistor = persistStore(store)